import { render } from "./Configuracion.vue?vue&type=template&id=88f6040e&scoped=true"
import script from "./Configuracion.vue?vue&type=script&lang=js"
export * from "./Configuracion.vue?vue&type=script&lang=js"

import "./Configuracion.vue?vue&type=style&index=0&id=88f6040e&scoped=true&lang=css"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88f6040e"]])

export default __exports__